import { GrossProfitMarginValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  values: GrossProfitMarginValues;
  onValuesChange: (field: keyof GrossProfitMarginValues, value: number) => void;
  translations: ToolsTranslations['grossProfitMargin'];
}

export default function CalculatorInputs({ values, onValuesChange, translations }: Props) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-gray-900 mb-4">{translations.inputs.title}</h3>
        
        <div className="space-y-4">
          <div>
            <label htmlFor="revenue" className="block text-sm font-medium text-gray-700 mb-2">
              {translations.inputs.revenue}
            </label>
            <div className="relative">
              <input
                id="revenue"
                type="number"
                value={values.revenue}
                onChange={(e) => onValuesChange('revenue', parseFloat(e.target.value) || 0)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="0"
                min="0"
                step="0.01"
              />
              <span className="absolute right-3 top-2 text-sm text-gray-500">kr</span>
            </div>
          </div>
          
          <div>
            <label htmlFor="cogs" className="block text-sm font-medium text-gray-700 mb-2">
              {translations.inputs.cogs}
            </label>
            <div className="relative">
              <input
                id="cogs"
                type="number"
                value={values.cogs}
                onChange={(e) => onValuesChange('cogs', parseFloat(e.target.value) || 0)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="0"
                min="0"
                step="0.01"
              />
              <span className="absolute right-3 top-2 text-sm text-gray-500">kr</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
